import React from 'react';
import { Link } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';

import '@grapecity/wijmo.styles/wijmo.css';
import './app.css';
import { CellMaker } from "@grapecity/wijmo.grid.cellmaker";
import { FlexGrid, FlexGridColumn } from '@grapecity/wijmo.react.grid';
import { FlexGridFilter } from "@grapecity/wijmo.react.grid.filter";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  fontWeight: {
    fontWeight: 900,
  },
});

function ProcessFlowSelTable(props) {
  const classes = useStyles();
  const { dataList, handleDelete, currentUser } = props;

  // console.log('currentUser',currentUser);

  const resdataList = dataList.filter(dataList => {
//    return dataList.exhaustCd         === currentUser.traderCd
//     ||
//    dataList.sect1TransportCd         === currentUser.traderCd ||
      return dataList.sect1TransportCd  === currentUser.traderCd
//    dataList.sect2TransportCd         === currentUser.traderCd ||
//    dataList.sect3TransportCd         === currentUser.traderCd ||
//    dataList.sect4TransportCd         === currentUser.traderCd ||
//    dataList.sect5TransportCd         === currentUser.traderCd ||
//    dataList.destination1Cd           === currentUser.traderCd ||
//    dataList.destination2Cd           === currentUser.traderCd ||
//    dataList.destination3Cd           === currentUser.traderCd ||
//    dataList.destination4Cd           === currentUser.traderCd ||
//    dataList.destination5Cd           === currentUser.traderCd ||
//    dataList.middleProcessingTraderCd === currentUser.traderCd ||
//    dataList.lastProcessingTraderCd   === currentUser.traderCd
})

  return (
    <>

      <FlexGrid  autoSearch={true} isReadOnly={true} selectionMode="ListBox" autoGenerateColumns={false} itemsSource={resdataList}>
        <FlexGridFilter />
        <FlexGridColumn binding="id" header="id" width={80}></FlexGridColumn>
        <FlexGridColumn binding="reserveName" header="処理フロー名称" width={120}></FlexGridColumn>
        <FlexGridColumn binding="exhaustName" header="排出事業場" width={200}></FlexGridColumn>
        <FlexGridColumn binding="wasteKindName" header="廃棄物種類" width={120}></FlexGridColumn>
        <FlexGridColumn binding="sect1TransportName" header="運搬業者" width={120}></FlexGridColumn>
        <FlexGridColumn binding="lastProcessingTraderName" header="最終処分場" width={120}></FlexGridColumn>
        <FlexGridColumn header="選択" binding="id" width={60} cellTemplate={CellMaker.makeLink({
          text: '<b>選択</b>',
          href: '/edi_d01_itemAdd/${item.id}',
          attributes: {
            rel: 'noopener noreferrer',
            tabIndex: -1
          }
        })} />
      </FlexGrid>
    </>

  );
}
export default ProcessFlowSelTable;
